module.exports = __webpack_public_path__ + "img/complaint.0e7e728e.svg";